var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    class: `fill-current  text-${_vm.color}`,
    attrs: {
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 477.3 477.3",
      "height": `${_vm.height}px` || '24px',
      "width": `${_vm.width}px` || '24px'
    }
  }, [_c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M255.6,73.65h-177c-5.5,0-10,4.5-10,10v117c0,5.5,4.5,10,10,10h177c5.5,0,10-4.5,10-10v-117\n\t\t\tC265.6,78.15,261.1,73.65,255.6,73.65z M245.6,190.65h-157v-97h157V190.65z"
    }
  })])]), _c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M467.2,432.65H299.6v-160h16.3c14.8,0,26.8,12.1,26.7,26.9c0,0.1,0,0.1,0,0.2v27.7c0,29.3,23.7,53,53,53s53-23.7,53-53\n\t\t\tv-158.2c0-16.4-6.1-32.2-17.3-44.3l-78.2-89.1l-15,13.2l60.6,69.1c-21.9,3.7-36.7,24.4-33,46.3c3.2,19.4,20,33.6,39.7,33.6\n\t\t\tc8.3-0.1,16.4-2.6,23.2-7.4v136.8c0,18.2-14.8,33-33,33s-33-14.8-33-33v-27.7c0.1-25.9-20.8-47-46.6-47.1h-0.1h-16.3V66.35\n\t\t\tc0-22.8-18.4-41.7-41.2-41.7H72.6c-22.8,0-41,19-41,41.7v366.3H10c-5.5,0-10,4.5-10,10s4.5,10,10,10h457.3c5.5,0,10-4.5,10-10\n\t\t\tS472.8,432.65,467.2,432.65z M405.4,177.95c-11.2,0-20.2-9.1-20.2-20.2c0-11.1,9.1-20.2,20.2-20.2c11.2,0,20.2,9.1,20.2,20.2\n\t\t\tC425.6,168.85,416.5,177.95,405.4,177.95z M279.6,432.65h-228V66.35c0-11.8,9.2-21.7,21-21.7h185.8c11.8,0,21.2,10,21.2,21.7\n\t\t\tV432.65z"
    }
  })])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }